import "./about.css";
import ME from "../../assets/1.png";
import { FaAward } from "react-icons/fa";
import { AiOutlineCalendar } from "react-icons/ai";
import { MdLocationPin } from "react-icons/md";

const About = ({ setActiveNav }) => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="about" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <AiOutlineCalendar className="about__icon" />
              <h5>Age</h5>
              <small>22 Years</small>
            </article>
            <article className="about__card">
              <MdLocationPin className="about__icon" />
              <h5>Location</h5>
              <small>Iran,Shiraz</small>
            </article>
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>+4 Years</small>
            </article>
          </div>
          <p>
            Hi, I’m <strong>Nima Sharifinia — a Fullstack Developer turned AI explorer.</strong> <br />
            From crafting sleek websites and mobile apps to diving deep into AI, Machine Learning, and Image Processing, I love turning complex ideas into smart, useful solutions. Let’s build something amazing together.
          </p>
          <a
            href="#contact"
            className="btn btn-primary"
            onClick={() => setActiveNav("#contact")}
          >
            Hire me
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
